import { render } from "./stt-return.vue?vue&type=template&id=5e396378&scoped=true&ts=true"
import script from "./stt-return.vue?vue&type=script&lang=ts"
export * from "./stt-return.vue?vue&type=script&lang=ts"

import "./stt-return.vue?vue&type=style&index=0&id=5e396378&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e396378"]])

export default __exports__